
import Vue from "vue";
import { BrowseStateBase } from "@/utils/browse/browse-state-base";

export default Vue.extend({
	data() {
		return {
			search: "",
		};
	},
	props: {
		state: {
			required: true,
			type: Object as () => BrowseStateBase
		}
	},
	computed: {
		icon(): string{
			return this.search ? "times" : "";
		}
	},
	watch: {
		"search": {
			handler(){
				if (this.search == "") {
					console.trace("Search changed", this.search);
				}
			}
		},
		"state.querySettings.searchQuery"() {
			if(this.state.querySettings.searchQuery==""){
				this.search = "";
			}
		}
	},
	methods: {
		onFocus(){
			this.$emit("focus");
		},
		onClear(){
			this.search = "";
			this.$emit("enter",this.search);
		},
		onEnter(){
			console.log("On enter", this.search);
			this.$emit("enter",this.search);
		}
	}
});
